<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore } from '../../../store';

import VideoContent from './components/VideoContent.vue'

const felixBagAuxStore = useFelixBagAuxStore();

const openContent = ref(false)
const audio = document.createElement("audio")
const idSubmenu = ref('')
onMounted(() => {
  felixBagAuxStore.pauseAfter(1000)

  felixBagAuxStore.muteVideo();
  audio.pause();
  audio.src = "https://overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/videobot/vivo/audios_parametrizados/Dicas+de+uso.mp3"
  audio.play();

});

const items = [
  {
    title: 'Como navegar',
    type: 'text',
    id: 'como_navegar',
    value: 1,
    props: {
      prependIcon: 'https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/26b42074-288f-4bc9-943f-d808c8c866ee.svg',
      appendIcon: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/1b595908-3f7a-451d-aa09-30178d5456fd.svg'
    },
  },
  {
    title: 'Seu quadro de avisos',
    id: 'quadro_de_avisos',
    value: 1,
    props: {
      prependIcon: 'https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/26b42074-288f-4bc9-943f-d808c8c866ee.svg',
      appendIcon: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/1b595908-3f7a-451d-aa09-30178d5456fd.svg'
    },
  },
  {
    title: 'Trilhas',
    id: 'trilhas',
    value: 1,
    props: {
      prependIcon: 'https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/26b42074-288f-4bc9-943f-d808c8c866ee.svg',
      appendIcon: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/1b595908-3f7a-451d-aa09-30178d5456fd.svg'
    },
  },
]

function showContent(item) {
  idSubmenu.value = item
  openContent.value = true
}
</script>

<template>
  <div id="dicas-de-uso">
    <v-row align-items="center" justify="space-evenly" class="header">
      <v-col cols="12" md="6" style="display: flex; flex-direction: column; align-items: start;">
        <v-btn @click="felixBagAuxStore.hideInteractive('dicas-de-uso'); audio.pause(); felixBagAuxStore.unmuteVideo()"
          variant="text" color="inherit"><img
            src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
            alt=""></v-btn>
        <p class="submenu-title">Dicas de uso</p>
      </v-col>

      <v-col md="6">
        <img
          src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/6d546e51-d7f2-476e-84d0-b23d2ed020fc.svg"
          alt="">
      </v-col>
    </v-row>

    <v-card variant="flat" class="mx-auto" max-width="300" style="margin-top: 5%;">
      <v-list>
        <v-list-item class="jb-save" :data-source="item.id" height="60px" @click="showContent(item)" v-for="(item, i) in items" :key="i" :value="item">
          <template v-slot:prepend>
            <div class="icon-wrapper">
              <img style="width: 15px;"
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/10d4affa-0770-43f1-8fa5-7561f064e83d.svg"
                alt="">
            </div>

            <v-list-item-title style="margin-left: 20px;" v-text="item.title"></v-list-item-title>
          </template>

          <template v-slot:append>
            <img style="width: 15px;"
              src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/1b595908-3f7a-451d-aa09-30178d5456fd.svg"
              alt="">
          </template>
        </v-list-item>

      </v-list>
    </v-card>

  </div>

  <VideoContent :item="idSubmenu" @close-content="openContent = false" v-if="openContent == true" />
</template>

<style scoped>
#dicas-de-uso {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  z-index: 1;
}

.header {
  height: 25%;
  background-color: #BC4AFF;
}

#dicas-de-uso .submenu-title {
  color: white;
  font-size: 20px;
  text-align: start;
  margin-left: 10%;
  margin-top: 10%;

}

.icon-wrapper {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F6E7FF;
  border-radius: 50%;
}
</style>